export const accountTypes = [
  // { name: 'Acc_Main', value: '10' },
  { name: "50$", value: "1" },
  { name: "250$", value: "2" },
  { name: "250_Phi", value: "27" },
  { name: "250_Thai", value: "28" },
  // { name: '350$', value: '3' },
  // { name: 'BM250', value: '4' },
  // { name: 'BM350', value: '6' },
  // { name: 'GG_ADS', value: '5' },
  // { name: 'BM_AGENT', value: '7' },
  // { name: 'BM_Unlimit', value: '8' },
  // { name: 'BM5_Unlimit', value: '9' },
  // { name: 'BM_Unlimit_Strong', value: '11' },
  { name: "nlm_share_phi", value: "12" },
  { name: "nlm_share_th", value: "30" },
  { name: "Green_3Day", value: "13" },
  { name: "902", value: "14" },
  { name: "Acc_Share_1500$", value: "15" },
  // { name: 'Google_Ads', value: '16' },
  // { name: 'Tiktok_Ads', value: '17' },
  // { name: 'Tiktok_Live', value: '18' },
  { name: "Acc_Pro", value: "19" },
  // { name: '902_1500$', value: '20' },
  { name: "Acc_Premium", value: "21" },
  { name: "Acc_Seeding", value: "22" },
  { name: "Acc_Topup", value: "23" },
  { name: "Acc_NLMNEW", value: "24" },
  { name: "Acc_Share_New", value: "25" },
  { name: "NLM_CLAIM", value: "26" },
  { name: "2line_new", value: "29" },
];

// export const accountTypesTransfer = [
//   { field: '50$', name: '250$', value: '2' },
//   { field: '50$', name: '350$', value: '3' },
// ];

export const setAccountTypeName = (val?: string) => {
  switch (val) {
    case "1":
      return "50$";
    case "2":
      return "250$";
    case "3":
      return "350$";
    case "4":
      return "BM250";
    case "5":
      return "GG_ADS";
    case "6":
      return "BM350";
    case "7":
      return "BM_AGENT";
    case "8":
      return "BM_Unlimit";
    case "9":
      return "BM5_Unlimit";
    case "10":
      return "Acc_Main";
    case "11":
      return "BM_Unlimit_Strong";
    case "12":
      return "nlm_share_phi";
    case "13":
      return "Green_3Day";
    case "14":
      return "902";
    case "15":
      return "Acc_Share_1500$";
    case "16":
      return "Google_Ads";
    case "17":
      return "Tiktok_Ads";
    case "18":
      return "Tiktok_Live";
    case "19":
      return "Acc_Pro";
    case "20":
      return "902_1500$";
    case "21":
      return "Acc_Premium";
    case "22":
      return "Acc_Seeding";
    case "23":
      return "Acc_Topup";
    case "24":
      return "Acc_NLMNEW";
    case "25":
      return "Acc_Share_New";
    case "26":
      return "NLM_CLAIM";
    case "27":
      return "250_Phi";
    case "28":
      return "250_Thai";
    case "29":
      return "2line_new";
    case "30":
      return "nlm_share_th";
    default:
      return "Undefinded";
  }
};

export const setAccountTypeValue = (val?: string) => {
  switch (val) {
    case "50$":
      return "1";
    case "250$":
      return "2";
    case "350$":
      return "3";
    case "BM250":
      return "4";
    case "GG_ADS":
      return "5";
    case "BM350":
      return "6";
    case "BM_AGENT":
      return "7";
    case "BM_Unlimit":
      return "8";
    case "BM5_Unlimit":
      return "9";
    case "Acc_Main":
      return "10";
    case "BM_Unlimit_Strong":
      return "11";
    case "nlm_share_phi":
      return "12";
    case "Green_3Day":
      return "13";
    case "902":
      return "14";
    case "Acc_Share_1500$":
      return "15";
    case "Google_Ads":
      return "16";
    case "Tiktok_Ads":
      return "17";
    case "Tiktok_Live":
      return "18";
    case "Acc_Pro":
      return "19";
    case "902_1500$":
      return "20";
    case "Acc_Premium":
      return "21";
    case "Acc_Seeding":
      return "22";
    case "Acc_Topup":
      return "23";
    case "Acc_NLMNEW":
      return "24";
    case "Acc_Share_New":
      return "25";
    case "NLM_CLAIM":
      return "26";
    case "250_Phi":
      return "27";
    case "250_Thai":
      return "28";
    case "2line_new":
      return "29";
    case "nlm_share_th":
      return "30";
    default:
      return "Undefinded";
  }
};
